import { render, staticRenderFns } from "./Welfare.vue?vue&type=template&id=fcdbe30e&scoped=true"
import script from "./Welfare.vue?vue&type=script&lang=js"
export * from "./Welfare.vue?vue&type=script&lang=js"
import style0 from "./Welfare.vue?vue&type=style&index=0&id=fcdbe30e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdbe30e",
  null
  
)

export default component.exports